/**
 * Canales Furniture — Biblioteca de materiales de entrenamiento.
 * PDFs y videos organizados por rol. Se muestran en /biblioteca y como
 * refuerzo dentro del comic reader.
 */

const HOST = "https://customer-assets-39nsmqrw.emergentagent.net";

export const MATERIALS = [
  {
    slug: "manager",
    label: { es: "Manager", en: "Manager" },
    color: "#0d1a3f",
    icon: "briefcase",
    comic_slug: "manager",
    items: [
      {
        type: "pdf",
        title: {
          es: "Checklist de Manager (Canales)",
          en: "Manager Checklist (Canales)",
        },
        description: {
          es: "Guía esencial para gestión eficiente y resultados extraordinarios en la tienda.",
          en: "Essential guide for efficient store management and extraordinary results.",
        },
        url: `${HOST}/job_furniture-mastery/artifacts/CanalesFurniture_ChecklistDeManager.pdf`,
        lang: "es",
      },
    ],
  },
  {
    slug: "vendedor",
    label: { es: "Vendedor", en: "Salesperson" },
    color: "#005BBB",
    icon: "briefcase",
    comic_slug: "ventas",
    items: [
      {
        type: "pdf",
        title: { es: "Checklist del Vendedor (EN)", en: "Salesperson Checklist" },
        description: {
          es: "Guía de bolsillo para ejecutar el proceso de venta paso a paso.",
          en: "Pocket guide to run the sales process step by step.",
        },
        url: `${HOST}/job_furniture-mastery/artifacts/ofl9jl2o_EngChecklistVendedor-Rev-1-.pdf`,
        lang: "en",
      },
      {
        type: "video",
        title: {
          es: "Cómo registrar una venta (Single Order Checkout)",
          en: "How to submit a sale (Single Order Checkout)",
        },
        description: {
          es: "Video interno mostrando el proceso completo de checkout.",
          en: "Internal walkthrough of the full checkout flow.",
        },
        url: `${HOST}/job_furniture-mastery/artifacts/8nskr8qr_submitting_sales_through_single_order_checkout_rough_cut_v1_v1%20%281080p%29.mp4`,
        lang: "en",
        duration: null,
      },
      {
        type: "video",
        title: { es: "Presentación Canales (Español)", en: "Canales Overview (Spanish)" },
        description: {
          es: "Video corporativo para nuevos vendedores.",
          en: "Corporate video for new salespeople.",
        },
        url: `${HOST}/job_furniture-mastery/artifacts/fuvqfezu_canales-spanish-recording.mp4`,
        lang: "es",
      },
      {
        type: "video",
        title: { es: "Canales Overview (English)", en: "Canales Overview (English)" },
        description: {
          es: "Video corporativo en inglés.",
          en: "Corporate video in English.",
        },
        url: `${HOST}/job_furniture-mastery/artifacts/4l5fc77n_canales-english-recording.mp4`,
        lang: "en",
      },
    ],
  },
  {
    slug: "servicio",
    label: { es: "Servicio al Cliente", en: "Customer Service" },
    color: "#E3000F",
    icon: "life-buoy",
    comic_slug: "servicio",
    items: [
      {
        type: "pdf",
        title: { es: "Servicio al Cliente (ES)", en: "Customer Service (SP)" },
        description: {
          es: "Manual de servicio: escuchar → disculpar → resolver → follow-up.",
          en: "Service manual: listen → apologize → solve → follow-up.",
        },
        url: `${HOST}/job_furniture-mastery/artifacts/d1bpqcrx_Customer-Service-SP.pdf`,
        lang: "es",
      },
    ],
  },
  {
    slug: "financiamiento",
    label: { es: "Financiamiento", en: "Financing" },
    color: "#16a34a",
    icon: "dollar-sign",
    comic_slug: "financiamiento",
    items: [
      {
        type: "pdf",
        title: {
          es: "Cómo agregar un Plan Montage",
          en: "How to add a Montage Protection Plan",
        },
        description: {
          es: "Paso a paso para vender la protección Montage al checkout.",
          en: "Step-by-step to sell Montage protection at checkout.",
        },
        url: `${HOST}/job_furniture-mastery/artifacts/k13ai4io_How-to-Add-a-Montage-Protection-Plan-APP_07312026.pdf`,
        lang: "en",
      },
    ],
  },
  {
    slug: "allstate",
    label: { es: "Allstate", en: "Allstate" },
    color: "#0033A0",
    icon: "shield",
    comic_slug: "allstate",
    items: [
      {
        type: "pdf",
        title: {
          es: "Allstate — Lanzamiento en tienda (ES)",
          en: "Allstate — Store Launch Training (SP)",
        },
        description: {
          es: "Entrenamiento de lanzamiento para el plan Allstate.",
          en: "Store launch training for the Allstate plan.",
        },
        url: `${HOST}/job_furniture-mastery/artifacts/da7363ux_Calanes_Allstate-Store-Launch-Training_Spanish-JUNE-27.pdf`,
        lang: "es",
      },
      {
        type: "video",
        title: {
          es: "Allstate: cómo cancelar un plan",
          en: "Allstate: how to cancel a plan",
        },
        description: {
          es: "Guía en video para cancelar planes Allstate desde el POS.",
          en: "Video guide to cancel Allstate plans from the POS.",
        },
        url: `${HOST}/job_furniture-mastery/artifacts/0k3gnv8l_allstate_protection_plans_for_brandsource__how_to_cancel_a_plan_v1%20%281080p%29.mp4`,
        lang: "en",
      },
    ],
  },
];

/** Lookup material entries linked to a comic (used by the Comic Reader). */
export const materialsForComic = (comicSlug) => {
  const found = MATERIALS.find((m) => m.comic_slug === comicSlug);
  return found ? found.items : [];
};

/** Extension → helpful mime label for the download button. */
export const materialLabel = (m, lang) => {
  if (m.type === "pdf") return lang === "es" ? "Ver PDF" : "Open PDF";
  if (m.type === "video") return lang === "es" ? "Ver video" : "Watch video";
  return lang === "es" ? "Abrir" : "Open";
};
